import { render, staticRenderFns } from "./ticketManagement.vue?vue&type=template&id=92152484&scoped=true&"
import script from "./ticketManagement.vue?vue&type=script&lang=js&"
export * from "./ticketManagement.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/ticketManagement/ticketManagement.css?vue&type=style&index=0&id=92152484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92152484",
  null
  
)

export default component.exports